// extracted by mini-css-extract-plugin
export default {"colorBrand":"#254a91","colorWhite":"#fff","colorBlueBright":"#81a9f2","NcwHomeBGImage":"NcwHomeBGImage_J2h7p","Overlay":"Overlay_bcFMc"};